export default "__VITE_ASSET__BqhENVwy__"